<template>
<!-- 头部第二行公共部分 ,没有标题，只有返回商城-->
  <div class="noReturnShopHead">
      <div class="bottom-head">
        <el-row class="contain">
          <el-col :span="22">
            <div class="head-logo">
              <img src="../../assets/img/logo7.png" alt="" />
            </div>
          </el-col>
          <!-- <el-col :span="2">
            <div>
             <el-button round class="returnButton">返回商城</el-button>
            </div>
          </el-col> -->
        </el-row>
      </div>
  </div>
</template>

<script>
export default {
  name: "noReturnShopHead",
  data() {
    return {

    };
  },
  methods: {

  },
  created() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom-head{
    background-color: #f64420;
    height: 94px;
    line-height: 94px;
}
.bottom-head .is-active{
  color: black;
  /* border-bottom: 2px solid #f64420;
  border-bottom-color: #f64420; */
  background-color: #f64420;
}
.bottom-head .el-menu-item {
  color: #777f8f !important;
}
.returnButton{
  border-radius: 16px;
	border: solid 1px #ffffff;
	background-color: #f64420;
  color: #fff
}
.head-logo img {
  text-align: center;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/components/common/noReturnShopHead.vue